import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import cogoToast from 'cogo-toast';
import {forgotPassword, resetPassword} from '../../request';
import logo from '../../assets/img/logo.png';

const option = {
    position: "top-right",
    hideAfter: 3,
};

const eyeStyle = {
    position: "absolute",
    top: "50%",
    right: "15px",
    transform: "translateY(-50%)",
    cursor: "pointer",
    color: "#8392a5",
};

const ForgotPassword = (props) => {

    document.title = "Forgot Password";

    // step 1 = request code by email, step 2 = enter code + new password
    const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(false);

    const [email, setEmail] = useState("");
    const [code, setCode] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleRequestCode = async (event) => {
        event.preventDefault();
        if (!email) {
            cogoToast.error("Please enter your email address", option);
            return;
        }
        setLoading(true);
        const result = await forgotPassword(email);
        setLoading(false);
        if (result.error) {
            cogoToast.error(result.payload, option);
            return;
        }
        cogoToast.success(result.payload, option);
        setStep(2);
    };

    const handleResetPassword = async (event) => {
        event.preventDefault();
        if (!code) {
            cogoToast.error("Please enter the code sent to your email", option);
            return;
        }
        if (newPassword.length < 6) {
            cogoToast.error("Password must be at least 6 characters", option);
            return;
        }
        if (newPassword !== confirmPassword) {
            cogoToast.error("Passwords do not match", option);
            return;
        }
        setLoading(true);
        const result = await resetPassword({email, code, newPassword});
        setLoading(false);
        if (result.error) {
            cogoToast.error(result.payload, option);
            return;
        }
        cogoToast.success(result.payload, option);
        props.history.push('/');
    };

    const renderButton = (label) => {
        if (loading) {
            return (
                <button className="btn btn-dark btn-block" disabled>
                    <span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>
                    Loading
                </button>
            );
        }
        return <button className="btn btn-dark btn-block">{label}</button>;
    };

    return (
        <div>
            <div className="content content-fixed content-auth">
                <div className="container">
                    <div className="media align-items-stretch justify-content-center ht-70p pos-relative">
                        <div className="sign-wrapper">
                            <div className="wd-100p">
                                <div className="text-center">
                                    <img src={logo} className="ht-120 mg-b-20 img-fluid" alt="logo"/>
                                </div>
                                <h3 className="tx-color-01 text-center mg-b-10 tx-18">Forgot Password</h3>

                                {step === 1 ? (
                                    <>
                                        <p className="tx-color-03 text-center tx-16 mg-b-40">
                                            Enter your email and we'll send you a reset code.
                                        </p>
                                        <form onSubmit={handleRequestCode}>
                                            <div className="form-group">
                                                <label>Email address</label>
                                                <input type="email" className="form-control"
                                                       placeholder="Enter your email address"
                                                       value={email}
                                                       onChange={(e) => setEmail(e.target.value)}
                                                       autoComplete="off"
                                                       required/>
                                            </div>
                                            {renderButton("Send Reset Code")}
                                        </form>
                                    </>
                                ) : (
                                    <>
                                        <p className="tx-color-03 text-center tx-16 mg-b-40">
                                            Enter the code sent by SMS to the phone number on the account
                                            for <strong>{email}</strong>, and your new password.
                                        </p>
                                        <form onSubmit={handleResetPassword}>
                                            <div className="form-group">
                                                <label>Reset code</label>
                                                <input type="text" className="form-control"
                                                       placeholder="Enter the 6-digit code"
                                                       value={code}
                                                       onChange={(e) => setCode(e.target.value)}
                                                       autoComplete="off"
                                                       required/>
                                            </div>
                                            <div className="form-group">
                                                <label>New password</label>
                                                <div style={{position: "relative"}}>
                                                    <input type={showNewPassword ? "text" : "password"}
                                                           className="form-control"
                                                           style={{paddingRight: "40px"}}
                                                           placeholder="Enter your new password"
                                                           value={newPassword}
                                                           onChange={(e) => setNewPassword(e.target.value)}
                                                           required/>
                                                    <i className={showNewPassword ? "fa fa-eye-slash" : "fa fa-eye"}
                                                       aria-hidden="true"
                                                       onClick={() => setShowNewPassword(!showNewPassword)}
                                                       style={eyeStyle}/>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label>Confirm new password</label>
                                                <div style={{position: "relative"}}>
                                                    <input type={showConfirmPassword ? "text" : "password"}
                                                           className="form-control"
                                                           style={{paddingRight: "40px"}}
                                                           placeholder="Re-enter your new password"
                                                           value={confirmPassword}
                                                           onChange={(e) => setConfirmPassword(e.target.value)}
                                                           required/>
                                                    <i className={showConfirmPassword ? "fa fa-eye-slash" : "fa fa-eye"}
                                                       aria-hidden="true"
                                                       onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                       style={eyeStyle}/>
                                                </div>
                                            </div>
                                            {renderButton("Reset Password")}
                                            <button type="button"
                                                    className="btn btn-link btn-block mg-t-10"
                                                    onClick={() => setStep(1)}>
                                                Didn't get a code? Try again
                                            </button>
                                        </form>
                                    </>
                                )}

                                <div className="text-center mg-t-20">
                                    <Link to="/">Back to Sign In</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
